__turbopack_context__.v({
  "readMore": "qVR3sW_readMore",
  "root": "qVR3sW_root",
});
